<section class="py-3">
  <div class="container-fluid card inner-scroll">
    <h3 class="text strat pt-3">Return to Dealer</h3>
    <form (ngSubmit)="saveReturnData()" [formGroup]="returnToDealerForm">
      <div class="row pt-3 g-3">
        @if (userDetails?.enrollmentType === "Company") {
        <div class="col-12 col-sm-6 col-md-3">
          <label for="fromBranchSelect">From Branch <span class="text-danger">*</span></label>
          <ng-select labelForId="fromBranchSelect" [items]="filteredActiveBranches" bindLabel="name" bindValue="_id" [multiple]="false"
            [clearable]="false" [searchable]="true" placeholder="Select From Branch"
            formControlName="company" class="ng-select-bootstrap" appendTo="body">
          </ng-select>
        </div>
        }
        <div class="col-12 col-sm-6 col-md-3">
          <label for="dealerSelect">Dealer<span class="text-danger">*</span></label>
          <ng-select labelForId="dealerSelect" [items]="dealerList" bindLabel="name" [multiple]="false"
            [clearable]="false" [searchable]="true" placeholder="Search or Select Dealer"
            formControlName="dealer" class="ng-select-bootstrap" appendTo="body"
            (search)="onDealerInputChange($event)" [searchFn]="customSearchFn"
            (scrollToEnd)="scrollDealer()">
          </ng-select>
        </div>
      </div>

      <div formArrayName="stock" class="stockArray">
        @for (item of stock.controls; track item; let i = $index) {
        <div class="row g-3 border-bottom pb-4 mb-2" [formGroupName]="i">
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreSizeSelect_' + i">Tyre Size<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreSizeSelect_' + i" [items]="tyreSizeObj.list" bindLabel="tyreSize" bindValue="tyreSize" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Size"
              formControlName="tyreSize" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              (scrollToEnd)="onScrollTyreSize()" (search)="onTyreSizeInputChange($event)"
              (close)="onSizeClose()" (clear)="onSizeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreMakeSelect_' + i">Tyre Make<span class="text-danger">*</span></label>
            <ng-select [labelForId]="'tyreMakeSelect_' + i" [items]="tyreMakeObj.list" [multiple]="false" [searchFn]="customSearchFn"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Make"
              formControlName="tyreMake" class="ng-select-bootstrap" appendTo="body"
              (change)="selectMake($event, i)" (search)="onTyreMakeInputChange($event)"
              (close)="onMakeClose()" (clear)="onMakeClose()">
            </ng-select>
          </div>
          <div class="col-12 col-sm-6 col-md-3">
            <label [attr.for]="'tyreModelSelect_' + i">Tyre Model<span class="text-danger"></span></label>
            <ng-select [labelForId]="'tyreModelSelect_' + i" [items]="tyreModelList[i].list" bindLabel="name" bindValue="name" [multiple]="false"
              [clearable]="true" [searchable]="true" placeholder="Search or Select Tyre Model"
              formControlName="tyreModel" class="ng-select-bootstrap" appendTo="body" [searchFn]="customSearchFn"
              [readonly]="!stock.at(i).get('tyreMake')?.value"
              (scrollToEnd)="scroll(i)" (search)="onTyreModelInputChange($event, i)"
              (close)="onModelClose(i)" (clear)="onModelClose(i)">
            </ng-select>
          </div>
          <div class="col-3 col-md-2">
            <label [attr.for]="'quantityInput_' + i">Total Quantity <span class="text-danger">*</span></label>
            <input [id]="'quantityInput_' + i" type="number" class="form-control no-spinner default-form-group-border" formControlName="quantity"
              name="quantity" required placeholder="Quantity" appBlockNumberSpecialchars [extraChars]="['.']" [appMaxLength]="10"/>
            @if (
            stock.at(i).get("quantity")?.invalid &&
            stock.at(i).get("quantity")?.touched
            ) {
            <div>
              @if (stock.at(i).get("quantity")?.errors?.['required']) {
                <small class="text-danger">Quantity is required</small>
              }
              @if (stock.at(i).get("quantity")?.errors?.['min']) {
                <small class="text-danger">Quantity must be at least 1</small>
              }
            </div>
            }
          </div>
          <div class="col-3 col-md-1 d-flex align-items-end justify-content-start gap-1">
            @if (i == stock.length - 1) {
            <button class="btn app-btn-primary" type="button" (click)="addItem(i)">
              <fa-icon [icon]="faPlus" class="fa-1x"></fa-icon>
            </button>
            }
            @if (stock.length > 1) {
            <button class="btn btn-danger" type="button" (click)="removeItem(i)">
              <fa-icon [icon]="faTrash" class="fa-1x"></fa-icon>
            </button>
            }
          </div>
        </div>
        }
      </div>

      <div class="text-danger pt-3">{{ responseMsg }}</div>
      <div class="row pt-3">
        <div class="col-12 text-end p-3">
          <button type="button" class="btn btn-outline-dark m-2" [routerLink]="'/order-list'" [disabled]="isLoading">
            Cancel
          </button>
          <button type="submit" [disabled]="returnToDealerForm.invalid || isLoading" class="btn app-btn-primary">
            Submit
            @if (isLoading) {
             <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
            }
          </button>
        </div>
      </div>
    </form>
  </div>
</section>